import React from 'react';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import classNames from 'classnames';

import css from './Card.module.scss';

const Card = ({
	images,
	src,
	alt,
	imgPosition,
	heading,
	description,
	primaryLink,
	secondaryLink,
	hideMobile,
	btnText,
}) => {
	return (
		<div
			className={hideMobile ? classNames(css.card, css.hideMobile) : css.card}
		>
			{imgPosition === 'left' && (
				<div
					data-aos="custom-fade-right"
					className={hideMobile ? 'showDesktop' : css.image}
				>
					<Img fixed={images[src].childImageSharp.fixed} alt={alt} />
				</div>
			)}
			<div
				className={css.contentWrapper}
				data-aos={`custom-fade-${imgPosition}`}
			>
				<h3>{heading}</h3>
				<p>{description}</p>
				{/* Show links only if any of the link is preset in json */}
				{(primaryLink || secondaryLink) && (
					<div className={css.links}>
						{primaryLink && (
							<Link
								to={primaryLink}
								className={classNames(css.primaryLink, 'btn btnGreen')}
							>
								{btnText}
							</Link>
						)}
						{secondaryLink && (
							<Link
								to={secondaryLink}
								className={`${css.secondaryLink} linkUnderline`}
							>
								Learn More
							</Link>
						)}
					</div>
				)}
			</div>
			{imgPosition === 'right' && (
				<div
					data-aos="custom-fade-left"
					className={hideMobile ? 'showDesktop' : css.image}
				>
					<Img fixed={images[src].childImageSharp.fixed} alt={alt} />
				</div>
			)}
		</div>
	);
};

export default Card;
